/**
 * The state context.
 * If requirement get complex then we should move to an abstraction, such as a library like redux or legend, that allows consumers to only subscribe to the part of state they need, along with other state niceness.
 * Our requirements of global state are currently, at the time of writing, quite simple. Adding an abstraction would probably be overengineering, and an unnecessary layer of complexity/thought.
 */

import React from 'react';

export type CloudsAndContentState = {
  permissions?: {
    canAddCloud: boolean;
  };
  version: string;
};

const ctx = React.createContext<CloudsAndContentState | null>(null);

/**
 * Contains the context value and updater for state related to clouds and content
 */
export function CloudsAndContentStateProvider({
  children,
  ...props
}: CloudsAndContentState & { children: React.ReactNode }) {
  return <ctx.Provider value={props}>{children}</ctx.Provider>;
}

/**
 * Use this to access clouds and content state from context.
 */
export function useState() {
  const auth = React.useContext(ctx);
  if (!auth) {
    throw Error('Tried to use state context without it being provided');
  }
  return auth;
}
